/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { Typography } from '@material-ui/core';
import { format as formatDate } from 'date-fns';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import ReportCard from 'components/ReportsModule/components/common/ReportCard';
import LwtTable, { ColumnProps } from 'components/@common/Table/LwtTable';
import { KeyStudentEngagementSpotCheckResult } from 'types/schema-generated-types';

const DATE_FORMAT = 'MM/dd/yyyy';

const getColumns: (t: TFunction) => ColumnProps<any>[] = (t: TFunction) => [
  {
    id: 'dateCompleted',
    label: t('Date'),
    sortKey: 'dateCompleted',
    getValue: item => (
      <Typography>{formatDate(new Date(item.dateCompleted), DATE_FORMAT)}</Typography>
    ),
    sortable: true
  },
  {
    id: 'template',
    label: t('Spot Check Type'),
    helpText: t('spotCheckType', { ns: 'ReportsHelpTableColumns' }),
    sortKey: 'template',
    getValue: item => <Typography>{t(item.template, { ns: 'KeyActivityTemplates' })}</Typography>,
    sortable: true
  },
  {
    id: 'wpm',
    label: t('Speed (WPM)'),
    helpText: t('wpm', { ns: 'ReportsHelpCommon' }),
    sortKey: 'wpm',
    getValue: item => <Typography>{item.wpm}</Typography>,
    sortable: true
  },
  {
    id: 'accuracy',
    label: t('Accuracy'),
    helpText: t('accuracy', { ns: 'ReportsHelpCommon' }),
    sortKey: 'lastLoginDate',
    getValue: item => <Typography>{item.accuracy}%</Typography>,
    sortable: true
  }
];

const SpotCheckTable: React.FC<{
  reportData?: KeyStudentEngagementSpotCheckResult[];
  loading: boolean;
}> = ({ reportData = [], loading }) => {
  const { t } = useTranslation([
    'Reports',
    'ReportsHelpCommon',
    'ReportsHelpTableColumns',
    'KeyActivityTemplates'
  ]);
  const columns = getColumns(t);

  return (
    <ReportCard title={t('Spot Checks')} loading={loading} reportData={reportData}>
      <LwtTable columns={columns} data={reportData} />
    </ReportCard>
  );
};

export default SpotCheckTable;
